import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Loader2 } from 'lucide-react';
import { useEffect } from 'react';
import { useToast } from '@/hooks/useToast';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

export function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const { user, loading, isAdmin, status, signOut, isRejected } = useAuth();
  const { toast } = useToast();

  useEffect(() => {
    if (isRejected) {
      toast({
        title: 'Acesso negado',
        description: 'Sua conta foi rejeitada pelo administrador.',
        variant: 'destructive',
      });
      signOut();
    }
  }, [isRejected, signOut, toast]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (isRejected) {
    return <Navigate to="/auth" replace />;
  }

  if (status === 'pending') {
    return <Navigate to="/pending-approval" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
